/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} from "../actions/auth/authActionTypes";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_PASSWORD_SUCCESS:
      return {
        resetPasswordSuccess: true,
        message: action.payload.message,
      };
    case RESET_PASSWORD_FAILURE:
      return {
        resetPasswordSuccess: false,
        error: action.err.message,
      };
    default:
      return state;
  }
}
